export const environment = {
  production: false,
  API_ENDPOINT: "https://api.joyschoolenglish.com/dev",
  PLAY_URL: "https://devplay.joyschoolenglish.com",
  DATE_FORMAT: "YYYY-MM-DD",
  ROLE_SUPER: "Super",
  ROLE_ADMIN: "Admin",
  ROLE_TEACHER: "Teacher",
  CONVERSATION_CATEGORY_ID: 13
};
